import { render, staticRenderFns } from "./ActionPersonShooter.vue?vue&type=template&id=70506f3f"
import script from "./ActionPersonShooter.vue?vue&type=script&lang=js"
export * from "./ActionPersonShooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports